import { Box } from '@jfs/ui-new'
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs'
import { useEffect, useState } from 'react'
import { useStores } from '../../../data/store'
import { ReportsList } from './ReportsList'
import { TabBar } from './TabBar'

const Downloads = ({ isSettlements }) => {
  const { setDownloadReportType } = useStores((store) => ({
    setDownloadReportType: store.settings.metaData.setDownloadReportType,
  }))

  const [selIndex, setSelectedIndex] = useState(isSettlements ? 1 : 0)
  useEffect(() => {
    setDownloadReportType(isSettlements ? 'SETTLEMENT' : 'TRANSACTION')
  }, [isSettlements, setDownloadReportType])
  const Tab = createMaterialTopTabNavigator()

  const tabs = [
    { name: 'Received', component: () => <ReportsList type={'TRANSACTION'} index={selIndex} /> },
    { name: 'Settled', component: () => <ReportsList type={'settlement'} index={selIndex} /> },
    { name: 'Refunded', component: () => <ReportsList type={'REFUND'} index={selIndex} /> },
  ]

  return (
    <Box f={1} bg={'WHITE'}>
      <Tab.Navigator
        tabBar={(props) => (
          <TabBar
            {...props}
            onTabChange={(index: number) => {
              setSelectedIndex(index)
              setDownloadReportType(index === 0 ? 'TRANSACTION' : index === 1 ? 'SETTLEMENT' : 'REFUND')
            }}
          />
        )}
        initialRouteName={isSettlements ? 'Settled' : 'Received'}>
        {tabs.map((tab: any) => (
          <Tab.Screen name={tab.name} children={(props) => <tab.component {...props} />} />
        ))}
      </Tab.Navigator>
    </Box>
  )
}

export { Downloads }
